import Image from 'next/image';
import { memo, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import styles from '../ProductCardImages.module.scss';
import Icon from '@/components/UI/icon/Icon';
import { useRouter } from 'next/router';
import Box from '@/components/UI/box/Box';
const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));
interface CarouselImagesProps {
  title: string;
  images: string[];
  isFirstCard?: boolean;
}
const CarouselImages = ({
  title,
  images,
  isFirstCard
}: CarouselImagesProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [current, setCurrent] = useState(0);
  const router = useRouter();
  const handleMove = index => {
    setCurrent(index);
  };
  const handleNext = () => {
    if (current < images?.length - 1) setCurrent(prev => prev + 1);
  };
  const handlePrev = () => {
    if (current > 0) setCurrent(prev => prev - 1);
  };
  const slide = ({
    index,
    key
  }) => {
    return <Box className={styles['slides-images']} component={'figure'} key={key} data-sentry-element="Box" data-sentry-component="slide" data-sentry-source-file="CarouselImages.tsx">
        <Image src={images[index]} alt={title} title={title} fill={true} objectFit="cover" {...isFirstCard ? {
        priority: index === 0,
        loading: index === 0 ? 'eager' : 'lazy'
      } : {
        loading: 'lazy'
      }} data-sentry-element="Image" data-sentry-source-file="CarouselImages.tsx" />
      </Box>;
  };
  return <Box onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-sentry-element="Box" data-sentry-component="CarouselImages" data-sentry-source-file="CarouselImages.tsx">
      <Box className={`${isHovered ? styles['navigation-container'] : styles['hidden']}`} data-sentry-element="Box" data-sentry-source-file="CarouselImages.tsx">
        {current !== 0 && <Box className={styles['navigation-button'] + ' ' + styles['right-button']} onClick={handlePrev} id="navigation-button-right">
            <Icon name="arrow-right-2" type="white" size={24} />
          </Box>}
        {current !== images?.length - 1 && <Box className={styles['navigation-button'] + ' ' + styles['left-button']} onClick={handleNext} id="navigation-button-left">
            <Icon name="arrow-left-1" type="white" size={24} />
          </Box>}
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="CarouselImages.tsx">
        <VirtualizeSwipeableViews enableMouseEvents navigation={'true'} axis="x-reverse" index={current} onChangeIndex={handleMove} slideRenderer={slide} slideCount={images?.length} data-sentry-element="VirtualizeSwipeableViews" data-sentry-source-file="CarouselImages.tsx" />
      </Box>
      {(router.asPath.includes('search') || router.asPath.includes('bookmarks')) && <Box className={styles['carousel-dots-container']}>
          <Box className={styles['carousel-dots-items-container']}>
            {images?.map((item, index) => <Box className={styles['carousel-dots-items'] + ' ' + `${current === index ? styles['carousel-active-dots-items'] : ''}`} onClick={() => {
          setCurrent(index);
        }} ref={(ref: HTMLDivElement) => {
          if (current === index) {
            if (!ref?.classList.contains('active-dot') && current >= 2) {
              // This condition solved unwanted scroll to top after closing any drawer in the page
              ref?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
              });
            }
            ref?.classList.add('active-dot');
          } else {
            ref?.classList.remove('active-dot');
          }
        }} key={'IMAGE_INDEX_' + index}></Box>)}
          </Box>
        </Box>}
    </Box>;
};
export default memo(CarouselImages);